import React from 'react'
import ReactDOM from 'react-dom'
import { IntlProvider, addLocaleData } from 'react-intl'
import enLocaleData from 'react-intl/locale-data/en'

import './index.css'
import './bootstrap.css'

import * as serviceWorker from './serviceWorker'
import App from './App'
import ApiProvider from './data/ApiProvider'
import { ThemeProvider } from './styledComponents'
import { buildTheme, defaultTheme } from './theme'
import { BrandingProvider, BrandingContext } from './context/BrandingContext'

addLocaleData(enLocaleData)

const baseUrl = process.env.REACT_APP_GATEWAY_URL
    ? process.env.REACT_APP_GATEWAY_URL
    : `${window.location.protocol}//${window.location.host}`

const render = () => {
    ReactDOM.render(
        <IntlProvider locale="en">
            <BrandingProvider>
                <BrandingContext.Consumer>
                    {config => (
                        <ApiProvider socketUrl={baseUrl} apiUrl={`${baseUrl}/api/v1`}>
                            <ThemeProvider theme={config.primaryColor !== defaultTheme.colorActivePrimary ? buildTheme(config.primaryColor) : defaultTheme}>
                                <App />
                            </ThemeProvider>
                        </ApiProvider>
                    )}
                </BrandingContext.Consumer>
            </BrandingProvider>
        </IntlProvider>,
        document.getElementById('root'),
    )
}

serviceWorker.register()

render()

if (module.hot) {
    module.hot.accept('./App', () => {
        render()
    })
}
